import { pageLevelLocalization } from '@/constant/localization';

import { historyYears } from './type';

const {
  content: {
    aboutUs: { history: historyLocalization },
  },
} = pageLevelLocalization;

export const HistoryInfoData = {
  [historyYears[1403]]: {
    note: {
      title: historyLocalization.year_1403.note.title,
      subtitle1: historyLocalization.year_1403.note.subtitle,
      author: historyLocalization.year_1403.note.author,
    },
    image: 'https://ircdn.zhaket.com/public/static-media/about/1403.png',
    day: '24',
    month: historyLocalization.year_1403.month,
    description: {
      title: historyLocalization.year_1403.descrption.title,
      subTitle: [
        historyLocalization.year_1403.descrption.subtitle1,
        historyLocalization.year_1403.descrption.subtitle2,
      ],
    },
  },
  [historyYears[1402]]: {
    note: {
      title: historyLocalization.year_1402.note.title,
      subtitle: historyLocalization.year_1402.note.subtitle,
      author: historyLocalization.year_1402.note.author,
    },
    image: 'https://ircdn.zhaket.com/public/static-media/about/1399.png',
    day: '08',
    month: historyLocalization.year_1402.month,
    description: {
      title: historyLocalization.year_1402.descrption.title,
      subTitle: [
        historyLocalization.year_1402.descrption.subtitle1,
        historyLocalization.year_1402.descrption.subtitle2,
        historyLocalization.year_1402.descrption.subtitle3,
        historyLocalization.year_1402.descrption.subtitle4,
      ],
    },
  },
  [historyYears[1398]]: {
    note: {
      title: historyLocalization.year_1398.note.title,
      subtitle: historyLocalization.year_1398.note.subtitle,
      author: historyLocalization.year_1398.note.author,
    },
    image: 'https://ircdn.zhaket.com/public/static-media/about/1398.png',
    day: '08',
    month: historyLocalization.year_1398.month,
    description: {
      title: historyLocalization.year_1398.descrption.title,
      subTitle: [
        historyLocalization.year_1398.descrption.subtitle1,
        historyLocalization.year_1398.descrption.subtitle2,
      ],
    },
  },
  [historyYears[1395]]: {
    note: {
      title: historyLocalization.year_1395.note.title,
      subtitle: historyLocalization.year_1395.note.subtitle,
      author: historyLocalization.year_1395.note.author,
    },
    image: 'https://ircdn.zhaket.com/public/static-media/about/1395.png',
    day: '01',
    month: historyLocalization.year_1395.month,
    description: {
      title: historyLocalization.year_1395.descrption.title,
      subTitle: [
        historyLocalization.year_1395.descrption.subtitle1,
        historyLocalization.year_1395.descrption.subtitle2,
      ],
    },
  },
  [historyYears[1393]]: {
    note: {
      title: historyLocalization.year_1393.note.title,
      subtitle: historyLocalization.year_1393.note.subtitle,
      author: historyLocalization.year_1393.note.author,
    },
    day: '12',
    image: 'https://ircdn.zhaket.com/public/static-media/about/1393.png',
    month: historyLocalization.year_1393.month,
    description: {
      title: historyLocalization.year_1393.descrption.title,
      subTitle: [
        historyLocalization.year_1393.descrption.subtitle1,
        historyLocalization.year_1393.descrption.subtitle2,
      ],
    },
  },
};
